<section class="d-flex align-items-stretch">

  <div id="primary-sidebar" class="d-flex flex-column flex-shrink-0 p-1 text-white bg-dark">
    <a [routerLink]="" class="d-flex align-items-center mb-3 mb-md-0 me-md-auto text-white text-decoration-none">
      <i class="fa-solid fa-house"></i>
      <span class="fs-4">Sidebar</span>
    </a>
    <hr>

    <div class="text-center">

      <img src="/assets/images/logo.png" alt="Ponderosa Metalworks" class="img-fluid p-4">
    </div>

    <ul class="nav nav-pills flex-column mb-auto">
      <li class="nav-item">
        <a class="nav-link text-white" [routerLink]="'/dashboard'" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
          <i class="fa-solid fa-house"></i>
          Dashboard
        </a>
      </li>

      <li class="nav-item" *ngFor="let item of navLinks">
        <a [routerLink]="item.url" routerLinkActive="active" class="nav-link text-white" aria-current="page" [routerLinkActiveOptions]="{exact: true}">
          <i *ngIf="item.icon" class="{{item.icon}}"></i>
          {{item.title}}
        </a>
      </li>
    </ul>

    <div class="copyright">
      <p class="text-center">© 2024 LabWorkz LLC</p>
    </div>
    <hr>
    <div class="dropdown">
      <a [routerLink]="" role="button" class="d-flex align-items-center text-white text-decoration-none dropdown-toggle" id="dropdownUser1" data-bs-toggle="dropdown" aria-expanded="false">
        <img src="https://randomuser.me/api/portraits/men/72.jpg" alt="" width="32" height="32" class="rounded-circle me-2">
        <strong>USER</strong>
      </a>
      <ul class="dropdown-menu dropdown-menu-dark text-small shadow" aria-labelledby="dropdownUser1">
        <li><a class="dropdown-item" [routerLink]="['/dashboard', 'settings']">Settings</a></li>
        <li><a class="dropdown-item" [routerLink]="['/dashboard/profile']">Profile</a></li>
        <li>
          <hr class="dropdown-divider">
        </li>
        <li><a class="dropdown-item" [routerLink]="['/sign-out']">Sign out</a></li>
      </ul>
    </div>
  </div>

</section>
